import { Button, useDataProvider, useNotify } from "react-admin";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

interface IShowCcaDocumentButton {
  schoolId: number;
  documentType: string;
  label: string;
}

const ShowCcaDocumentButton = ({
  schoolId,
  documentType,
  label,
}: IShowCcaDocumentButton) => {
  const provider = useDataProvider();
  const notify = useNotify();

  const getDocumentUrl = () => {
    provider
      .customGetOne(`schools/${schoolId}`)
      .then(({ data }: any) => {
        let pdfUrl = "";

        switch (documentType) {
          case "readme":
            pdfUrl = data.ccaReadmePdfUrl;
            break;
          case "event":
            pdfUrl = data.ccaEventPdfUrl;
            break;
        }

        if (pdfUrl) {
          window.open(pdfUrl, "_blank");
        } else {
          notify("The PDF Url doesn't exist.", "warning");
        }
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
      });
  };

  return (
    <>
      <Button onClick={getDocumentUrl} label={label} startIcon={<PictureAsPdfIcon />} />
    </>
  );
};

export default ShowCcaDocumentButton;
